import { Injectable, Optional } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { AppCheck } from '@angular/fire/app-check';
import { connectFunctionsEmulator, Functions, getFunctions, HttpsCallable, httpsCallable } from 'firebase/functions';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FirebaseService {
   private functions: Functions;

   /**
    * Injecting the app and App Check (both provided in app.config.ts) is what
    * initializes them, so every callable leaves with an App Check token however
    * little else the page injects. AppCheck is optional for tests.
    */
   constructor(app: FirebaseApp, @Optional() appCheck: AppCheck | null) {
      void appCheck;
      this.functions = getFunctions(app, 'europe-central2');
      if (environment.connectFunctionsEmulator) {
         connectFunctionsEmulator(this.functions, 'localhost', 5001);
      }
   }

   public getFunction(name: string): HttpsCallable {
      return httpsCallable(this.functions, name);
   }
}
